import React, { useCallback } from "react";
import { Breadcrumb } from "semantic-ui-react";
import { useLMSGlobalReducer } from "../LmsGlobalStore";
import { GlobalConstants } from "../../constants/GlobalConstants";
import { isGuid } from "../../../Helpers";

const LmsBreadcrumbsMenu = ({ history }) => {
  const [{ activeHistory: { allHistory }, activeTab }] = useLMSGlobalReducer();
  const allHistoryIndexed = allHistory?.map((historyObj, index) => ({ ...historyObj, index }));
  const historyToRender = allHistory?.length > 3 ? allHistoryIndexed?.slice(allHistoryIndexed?.length - 3) : allHistoryIndexed;
  const formattedLinkText = useCallback((pathname, index) => {
    if (index === 0 && activeTab?.title) {
      return activeTab?.title;
    }
    else if (pathname?.includes("/")) {
      const suffixId = pathname?.length > GlobalConstants.DefaultValues.GUID_LENGTH ? pathname.substring(pathname.length - GlobalConstants.DefaultValues.GUID_LENGTH, pathname.length) : null;
      if (suffixId && isGuid(suffixId)) {
        return suffixId;
      }
      else {
        return pathname?.substring(pathname.lastIndexOf("/") + 1, pathname.length);
      }
    }

    return pathname;
  }, [allHistory]);

  return (
    <Breadcrumb>
      {historyToRender?.map((historyObj, i) => {
        return <>
          {i !== 0 && <Breadcrumb.Divider key={i} icon="right chevron" />}
          <Breadcrumb.Section
            className="lms-breadcrumb-section-link"
            key={`Breadcrumb${i}`}
            link={i !== historyToRender?.length - 1}
            active={i === historyToRender?.length - 1}
            onClick={() => {
              if (i !== historyToRender?.length - 1) {
                history.replace(historyObj?.pathname, { isGoBack: true, historyIndex: historyObj?.index });
              }
            }}
          >
            {formattedLinkText(historyObj?.pathname?.substring(1), historyObj?.index)}
          </Breadcrumb.Section>
        </>;
      })}
    </Breadcrumb>
  );
};

export default LmsBreadcrumbsMenu;